import { FormContextValues } from '@dreryk/react-common';
import { Heading, SecondaryText, StyledFlex, Toggle } from '@dreryk/react-components';

import { aiAssistantSettingsPanelTranslationKeys } from '../../../translations';

import { AiAssistantSettingsEnabledFieldFormBeanPart } from './AiAssistantSettingsEnabledField.types';

type AiAssistantSettingsEnabledFieldProps = Readonly<
   Pick<FormContextValues<AiAssistantSettingsEnabledFieldFormBeanPart>, 'register'> & { disabled: boolean }
>;

export const AiAssistantSettingsEnabledField = (props: AiAssistantSettingsEnabledFieldProps): JSX.Element => {
   return (
      <StyledFlex gap={'12px'} alignItems={'start'}>
         <Toggle testId={'enabled'} controller={props.register('enabled')} disabled={props.disabled} />
         <StyledFlex direction={'column'}>
            <Heading
               testId={'enableAiAssistant'}
               type={'h2'}
               content={aiAssistantSettingsPanelTranslationKeys.enableAiAssistant}
               margin={'0px'}
            />
            <SecondaryText
               testId={'enableAiAssistantDescription'}
               text={aiAssistantSettingsPanelTranslationKeys.enableAiAssistantDescription}
            />
         </StyledFlex>
      </StyledFlex>
   );
};
